/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.17",
    versionName: "0.2.0-nightly.2025.11.17",
    versionChannel: "nightly",
    buildDate: "2025-11-17T00:07:40.040Z",
    commitHash: "451a653bb5e532be33d5744f0e74851771bf986e",
};
